<template>
    <div class="zyzcBox">
        <div class="fenlBox">
         <div class="listTitle" v-for="(item,index) in list" :key="index" @click="openLink(item.url)">
            <img class="eduImg" src="@/assets/home/ser9.png" alt="">
            <p>{{item.name}}</p>
          </div>
        </div>
    </div>
  </template>
  
  <script>
      export default{
        data(){
          return{
            list:[
              {
                name:'河北省咨询工程师继续教育入口',
                // url:'http://cd.yunzikongjian.com/Jzxh/Login.aspx',
				url:'https://cd.yunzikongjian.com/index.html'
              },
              {
                name:'中咨协咨询师继续教育培训入口',
                url:'https://zxgcsjxjy.lanmaiedu.com/index.html'
              }
            ]
          }
        },
        methods:{
          // 打开链接地址
          openLink(url){
            // this.$router.push({
            //   path:url
            // })
            window.open(url,'_blank')
          }
        }
      }
  </script>
  
  <style lang="less" scoped>
  
    .zyzcBox{
      width: 100%;
      min-height: 100vh;
      background: #f0f2f5 url(~@/assets/bgst.jpeg) no-repeat 50%;
      background-size: 100%;
      padding: 300px 0 144px;
    }
    .fenlBox{
        position: fixed;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
        width: 50%;
        display: flex;
        justify-content: space-between;
    }
    .listTitle{
      width: 40%;
      height: 300px;
      background-color: #fff;
      border-radius: 10px;
      font-size: 24px;
      color: #327ee0;
      text-align: center;
      padding-top: 50px;
      cursor: pointer;
    }
    .eduImg{
        width: 100px;
        height: 100px;
        margin-bottom: 30px;
    }
  </style>